import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { IPopover, PopoverMenu } from '@gem/ui-kit';

import {
  IMediaMessageSubmitMenuParams,
  useMediaMessageSubmitMenuPresenter,
} from './MediaMessageSubmitMenu.presenter';

interface IMediaMessageSubmitMenuProps extends IMediaMessageSubmitMenuParams {
  popover: IPopover;
}

export const MediaMessageSubmitMenu: FC<IMediaMessageSubmitMenuProps> = observer(
  ({ popover, ...props }) => {
    const presenter = useMediaMessageSubmitMenuPresenter(props);

    if (!presenter.isShow) {
      return null;
    }

    return (
      <PopoverMenu
        menuItems={presenter.menuItems}
        reference={popover.containerRef.current}
        placement="top-end"
        isOpened={popover.isOpened}
        onClose={popover.close}
      />
    );
  }
);
